import React, {Component} from "react";
import {
  View,
  Image,
  TouchableOpacity,
  FlatList,
  ScrollView,
} from "react-native";
import {icons} from "../theme/icons";
import {
  appStyles,
  customerLocationStyles,
  viewCartStyles,
} from "../theme/styles";
import TextView from "../components/TextView";
import {
  viewCartRequest,
  changeCountCartRequest,
  removeItemCartRequest,
} from "../utils/api";
import LinearGradient from "react-native-linear-gradient";
import {blueLightColor, blueDarkColor} from "../theme/colors";
import {persianNumber, priceString} from "../utils/utils";
import Waiting from "../components/Waiting";
import Button from "../components/Button";
import CartItem from "../components/CartItem";
import {hp} from "../utils/responsive";

export default class ViewCartScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      waiting: false,
      orders: [],
      info: null,
    };
  }

  _keyExtractor = (item, index) => index.toString();

  renderRow({item, index}) {
    return (
      <CartItem
        data={item}
        onChange={number => {
          this.setState({
            waiting: true,
          });
          changeCountCartRequest(item.id, number, (isConnect, response) => {
            if (isConnect && response.isSuccess) {
              this.getData();
            } else {
              this.setState({
                waiting: false,
              });
            }
          });
        }}
        onRemove={() => {
          this.setState({
            waiting: true,
          });
          removeItemCartRequest(item.id, (isConnect, response) => {
            if (isConnect && response.isSuccess) {
              this.getData();
            }
          });
        }}
      />
    );
  }

  renderHeader() {
    return (
      <View
        style={{
          backgroundColor: "white",
          borderBottomLeftRadius: 20,
          borderBottomRightRadius: 20,
        }}>
        {this.state.info != null ? (
          <View
            style={[
              appStyles.shadow,
              {
                margin: 20,
                backgroundColor: "white",
                borderRadius: 15,
                padding: 15,
              },
            ]}>
            <TextView
              style={{
                color: "#4D4C53",
                fontSize: hp(2),
                textAlign: "center",
                marginBottom: 10,
              }}>
              هزینه درمان : {priceString(this.state.info.price_therapy)} تومان
            </TextView>
            <View style={viewCartStyles.lineVert} />
            <View style={appStyles.rowBetween}>
              <TextView
                style={{color: "#31BFCF", textAlign: "center", fontSize: 12}}>
                سهم مددجو : {priceString(this.state.info.price_sick_share)}{" "}
                تومان
              </TextView>
              <View style={viewCartStyles.lineHorz} />
              <TextView
                style={{color: "#31CF75", textAlign: "center", fontSize: 12}}>
                هزینه بیمه : {priceString(this.state.info.price_insurance)}{" "}
                تومان
              </TextView>
            </View>
            <View style={viewCartStyles.lineVert} />
            <View style={appStyles.rowBetween}>
              <TextView
                style={{color: "#31BFCF", textAlign: "center", fontSize: 12}}>
                تعداد خدمت : {persianNumber(this.state.info.number_all)}
              </TextView>
              <View style={viewCartStyles.lineHorz} />
              <TextView
                style={{color: "#FF6555", textAlign: "center", fontSize: 12}}>
                هزینه رفت و آمد : {priceString(this.state.info.price_sweep)}{" "}
                تومان
              </TextView>
            </View>
            <View style={viewCartStyles.lineVert} />
            <TextView
              style={{
                color: "#4D4C53",
                fontSize: hp(2),
                textAlign: "center",
                marginTop: 10,
              }}>
              مبلغ قابل پرداخت : {priceString(this.state.info.price_pay)} تومان
            </TextView>
          </View>
        ) : null}
      </View>
    );
  }

  render() {
    return (
      <View style={appStyles.flex1}>
        <View style={[appStyles.toolbarWraper, {height: hp(7)}]}>
          <Image
            source={icons["ad"]}
            style={[appStyles.toolbarIcon, {tintColor: "#31BFCF"}]}
          />
          <TextView style={appStyles.toolbarTitle}>تکمیل سفارش</TextView>
          <TouchableOpacity
            onPress={() => {
              this.props.navigation.goBack();
            }}>
            <Image source={icons["back"]} style={appStyles.backIcon} />
          </TouchableOpacity>
        </View>
        <LinearGradient
          colors={[blueDarkColor, blueLightColor]}
          style={[viewCartStyles.wraper, {minHeight: hp(100)}]}>
          <ScrollView>
            <View style={{marginBottom: hp(20)}}>
              <FlatList
                data={this.state.orders}
                ListHeaderComponent={this.renderHeader.bind(this)}
                ListFooterComponent={() => <View style={{minHeight: hp(19)}} />}
                renderItem={this.renderRow.bind(this)}
                keyExtractor={this._keyExtractor}
              />
            </View>
          </ScrollView>
        </LinearGradient>
        <View
          style={[
            appStyles.bottomView,
            appStyles.center,
            appStyles.shadow,
            {minHeight: hp(19)},
          ]}>
          <Button
            style={customerLocationStyles.button}
            text='تایید و ادامه'
            textStyle={customerLocationStyles.buttonText}
            showArrow={true}
            onPress={() => {
              if (this.state.info.number_all > 0) {
                this.props.navigation.navigate("completeOrder");
              }
            }}
          />
        </View>
        <Waiting waiting={this.state.waiting} />
      </View>
    );
  }

  componentWillMount() {
    this.getData();
  }

  getData() {
    this.setState({
      waiting: true,
    });
    viewCartRequest((isConnect, response) => {
      this.setState({
        waiting: false,
      });
      if (isConnect && response.isSuccess) {
        console.log(response.data.allinfo.number_all);
        if (
          response.data.allinfo == null ||
          response.data.allinfo.length == 0
        ) {
          this.props.navigation.goBack();
        }
        this.setState({
          info: response.data.allinfo,
          orders: response.data.orderdetails,
        });
      }
    });
  }
}
